import { render, staticRenderFns } from "./FileDownloader.vue?vue&type=template&id=6c524118"
import script from "./FileDownloader.vue?vue&type=script&lang=ts"
export * from "./FileDownloader.vue?vue&type=script&lang=ts"
import style0 from "./FileDownloader.vue?vue&type=style&index=0&id=6c524118&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports